import { z } from 'zod';
export const accessTypeSchema = z.enum(['grant', 'deny']);
export const entityKindSchema = z.enum([
    'ownership',
    'portfolio',
    'property',
    'unit',
    'contract',
    'invoice',
    'document',
    'bank_account',
    'income_schedule',
    'expense_schedule',
]);
export const accessLevelSchema = z.enum(['read', 'write']);
export const entityRoleSchema = z.enum([
    'owner',
    'admin',
    'property_manager',
    'agent',
    'board_member',
]);
const entityKeyPattern = new RegExp(`^(${entityKindSchema.options.join('|')}):.+$`);
const entityKeySchema = z.string().refine((s) => entityKeyPattern.test(s), {
    message: 'Key must match "entityKind:displayId" pattern',
});
export const entityPermissionNodeSchema = z.object({
    access: accessTypeSchema,
    accessLevel: accessLevelSchema.optional(),
    canManage: z.boolean().optional(),
    children: z
        .record(entityKeySchema, z.lazy(() => entityPermissionNodeSchema))
        .optional(),
});
export const ownershipPermissionSchema = z.object({
    role: entityRoleSchema,
    access: accessTypeSchema,
    accessLevel: accessLevelSchema.optional(),
    canManage: z.boolean().optional(),
    children: z.record(entityKeySchema, entityPermissionNodeSchema).optional(),
});
const permissionRootKeySchema = z
    .string()
    .refine((s) => s === 'personal' || /^ownership:.+$/.test(s), {
    message: 'Key must be "ownership:<displayId>" or "personal"',
});
export const userPermissionsSchema = z.record(permissionRootKeySchema, ownershipPermissionSchema);
//# sourceMappingURL=permissions.js.map